import { render, staticRenderFns } from "./HeraFormSearch.vue?vue&type=template&id=6823ca46&"
import script from "./HeraFormSearch.vue?vue&type=script&lang=js&"
export * from "./HeraFormSearch.vue?vue&type=script&lang=js&"
import style0 from "./HeraFormSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports